<template>
  <div>
    <v-card class="pa-2" flat>
      <!-- <v-btn small @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
      > -->
      <template
        v-if="
          $store.state.isonlyread ||
          $store.state.CARGO.id == 1 ||
          $store.state.CARGO.id == 14 ||
          $store.state.CARGO.id == 15 ||
          $store.state.CARGO.id == 20 ||
          $store.state.CARGO.id == 25 ||
          $store.state.CARGO.id == 26 ||
          $store.state.CARGO.id == 27 ||
          $store.state.CARGO.id == 21
        ">
        <!-- <template> -->
        <v-container class="py-0" fluid> 
          <div class="row">
            <div class="col-xs-12">
              <v-data-table :headers="[{text: '', value:'x',align:'left'}]" :items="[{x:'Datos del usuario, sede y sucursal actual'}]" :single-expand="true" :expanded.sync="expanded2" item-key="xid" disable-pagination hide-default-footer hide-default-header dense :show-expand="true" class="elevation-0" >
                <template v-slot:[`item.porcentaje_avance`]="{ item }">
                    <span> {{ item.porcentaje_avance }} % </span>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td v-if="user"  :colspan="headers.length" class="ma-0 py-0 px-2">
                      <h5 class="mb-0"><b>Usuario:</b> {{ user.nombres }} {{ user.pri_apellido }} {{ user.seg_apellido }}</h5>
                      <p class="my-1">
                        <b>ID/Sede:</b> {{ $store.state.CARGO.sede.id }} - {{ $store.state.CARGO.sede.nombre }}
                      </p>
                      <b>Sucursales: </b>
                      <v-row no-gutters>
                        <v-col v-for="(se, ind) in sucursales" :key="ind + 5" class="mb-0 pl-4" sm="3">
                          <p class="mb-0">
                            <small>
                              <b> [Nro. {{ se.sucursal.numero_sucursal }}]</b> nit: {{ se.sucursal.nro_nit }}</small
                            >
                          </p>
                          <p v-if="se.punto_venta.nombre">
                            <small>
                              <b>[{{ se.punto_venta.codigo_punto_venta }}]</b> {{ se.punto_venta.nombre }} -
                              {{ se.punto_venta.descripcion }}</small
                            >
                          </p>
                          <p v-else class="ma-0">
                            <small class="ml-0"><b>Sin punto de venta</b></small>
                          </p>
                        </v-col>
                      </v-row>  
                    </td>
                </template>
              </v-data-table> 
              <v-divider class="mt-0" color="green" />
            </div>
          </div>

          <div class="row mt-0 pt-0" v-if="enviosNetsuite1 && enviosNetsuite1.xid">
            <div class="col-xs-12 ma-0" >
              <v-data-table :headers="[{text: '', value:''}]" :items="[{}]" :single-expand="true" :expanded.sync="expanded" item-key="xid" disable-pagination hide-default-footer hide-default-header dense :show-expand="enviosNetsuite1.detalle!=null" class="elevation-0" >
                <template v-slot:header="{ header }">
                  <div class="row justify-center no-gutters">
                    <div class="col-xs-6 col-sm-3 ma-0 pa-0">
                      <v-card class="text-center mx-1 pa-4 mb-4 xcardnet-orange">
                        <b>Recibos generados</b> 
                        <p> <b> {{ enviosNetsuite1.cantidad_recibos_generados }} </b> </p>
                      </v-card>
                    </div>
                    <div class="col-xs-6 col-sm-3 ma-0 pa-0">
                      <v-card class="text-center mx-1 pa-4 mb-4 xcardnet-verde">
                        <b>Recibos enviados</b> 
                        <p> <b> {{ enviosNetsuite1.cantidad_recibos_enviados_netsuite }} </b> </p>
                      </v-card>
                    </div>
                    <div class="col-xs-6 col-sm-3 ma-0 pa-0">
                      <v-card class="text-center mx-1 pa-4 mb-4 xcardnet-rojo">
                        <b>Recibos faltantes</b>  
                        <p> <b> {{ enviosNetsuite1.cantidad_recibos_faltantes_netsuite }} </b> </p>
                      </v-card>
                    </div>
                    <div class="col-xs-6 col-sm-3 ma-0 pa-0">
                      <v-card class="text-center mx-1 pa-4 mb-4 xcardnet-purpura">
                        <b>Avance</b>  
                        <p> <b> {{ enviosNetsuite1.porcentaje_avance }} </b> % </p>
                      </v-card>
                    </div> 
                  </div>
                </template>
                <template v-slot:[`item.porcentaje_avance`]="{ item }">
                    <span> {{ item.porcentaje_avance }} % </span>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" v-if="enviosNetsuite1.detalle" class="ma-0 pa-0">
                      <v-data-table
                        :headers="headersDeta"
                        :items="enviosNetsuite1.detalle"
                        disable-pagination hide-default-footer 
                        dense
                        class="elevation-0 ma-0 pa-0">
                        <template v-slot:[`item.porcentaje_avance`]="{ item }">
                            <span> {{ item.porcentaje_avance }} % </span>
                        </template>
                      </v-data-table>
                    </td>
                </template>
              </v-data-table> 
              <v-divider class="mt-0" color="grey" />
            </div> 
          </div> 
        </v-container>

        <v-card-text> 
          <div xstyle="max-height: 50vh;overflow-y: scroll;">
          <v-data-table
            :headers="headers"
            :items-per-page="-1" 
            :items="items"
            :loading="loadingrecibos"
            fixed-header
            height="calc(100vh - 245px)"
            class="elevation-10 pb-3 tabla-recibos"
            :search="search">
            <template v-slot:top>
              <v-row class="pt-5 px-5">
                <v-toolbar-title v-if="isbenitojuarez"> Recibos Benito Juarez</v-toolbar-title>
                <v-toolbar-title v-else class="ml-3">Comprobantes de pagos</v-toolbar-title>
                <v-spacer></v-spacer> 
                
                <v-btn rounded small @click="openUpiMomentaneoFact()" v-if="vermomentaneo()">
                  <v-icon color="blue">mdi-information</v-icon>
                </v-btn>

                <v-btn
                  v-if="
                    $store.state.CARGO.id == 1 ||
                    $store.state.CARGO.id == 14 ||
                    $store.state.CARGO.id == 15 ||
                    $store.state.CARGO.id == 25 ||
                    $store.state.CARGO.id == 20 ||
                    $store.state.CARGO.id == 21
                  "
                  rounded
                  small
                  color="primary"
                  @click="openDialogAddRecibo">
                  <v-icon>mdi-plus</v-icon>
                  {{ isbenitojuarez ? 'Crear Recibo BJ' : 'Registrar Cobro' }}
                </v-btn>
                <v-btn
                  v-if="
                    $store.state.isonlyread ||
                    $store.state.CARGO.id == 1 ||
                    $store.state.CARGO.id == 14 ||
                    $store.state.CARGO.id == 15 ||
                    $store.state.CARGO.id == 25 ||
                    $store.state.CARGO.id == 26 ||
                    $store.state.CARGO.id == 20 ||
                    $store.state.CARGO.id == 27 ||
                    $store.state.CARGO.id == 21
                  "
                  rounded
                  small
                  class="mx-2"
                  color="success"
                  @click="descargarexcel()">
                  <v-icon>mdi-download</v-icon> Descargar
                </v-btn>
                <v-btn
                  v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 26 || $store.state.DATA_USER.id==3506"
                  rounded
                  small
                  dark
                  class="mx-2"
                  color="purple"
                  @click="recaudacionopen()">
                  <v-icon>mdi-download</v-icon> Recaudacion
                </v-btn>

                <VerificarNet ref="refVerificarNet" v-show="$store.state.CARGO.id != 27" />

                <v-col cols="12" class="px-2 py-1"> 
                  <filter-recibos
                    :date-start.sync="date_start"
                    :date-end.sync="date_end"
                    :status.sync="estado"
                    v-on:refrescar="loadRecibos" 
                    @clicked="loadRecibos()"></filter-recibos>
                </v-col>
                <v-col cols="12" class="pa-2 pb-0">
                  <v-row>
                    <v-col cols="12" sm="4" lg="3" v-if="$store.state.NETSUITE_VISIBLE && $store.state.CARGO.id != 26">
                      <v-combobox
                        v-model="filtroNetEstado"
                        :items="['ENVIADO A LA COLA','REGISTRADO EN NETSUITE','FALLO DE RESGITRO']"
                        class="mt-0"
                        label="Filtrar por Estado Netsuite"
                        clearable
                        hide-details
                        outlined
                        dense
                      />
                    </v-col>

                    <v-col>
                      <v-text-field dense outlined v-model="search" append-icon="mdi-magnify" label="Buscar"></v-text-field>
                    </v-col>

                    <v-col sm="1">
                      <v-tooltip bottom >
                        <template #activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" @click="loadRecibos()" v-on="on" color="orange"> mdi-refresh </v-icon>
                        </template>
                        Refrescar
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item="{ item }">
              <tr :class="{'net-green': item.is_impuestos_netsuite || item.netsuite_id}">
                <td>{{ item.index }}</td>
                <td>{{ item.is_impuestos_netsuite?'SI':'NO' }}</td>
                <td>{{ item.nombre_depositante }}</td>
                <td>{{ item.numero_recibo }}</td>
                <td>{{ item.detalle.length }}</td>
                <td>{{ item.fecha_pago }}</td>
                <td>{{ item.fecha_registro }}</td>
                <td>{{ item.estado_integracion }}</td>
                <td>   
                  <v-tooltip bottom vv-if="$store.state.CARGO.id != 27">
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" @click="openDialogDetail(item)" v-on="on" color="light-blue"> mdi-eye </v-icon >
                    </template>
                    Ver Recibo de {{ item.nombre_depositante }}
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    v-if="
                      !$store.state.isonlyread &&
                      item.estado &&
                      !item.factura_id &&
                      fechavalidaanular(item.fecha_registro, today)
                    ">
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" @click="cancelRecibo(item)" v-on="on" color="black"
                        >mdi-file-cancel</v-icon
                      >
                    </template>
                    Anular Recibo
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="$store.state.NETSUITE_VISIBLE && ($store.state.CARGO.id==14 || $store.state.CARGO.id==15 || $store.state.CARGO.id==1) && !item.netsuite_id">
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" @click="enviarANetSuite(item)" v-on="on" color="orange"> mdi-rotate-right-variant </v-icon>
                    </template>
                    Enviar al Netsuite
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="$store.state.NETSUITE_VISIBLE && item.netsuite_id && !item.is_impuestos_netsuite && item.factura_id && ($store.state.CARGO.id==14 || $store.state.CARGO.id==15 || $store.state.CARGO.id==1)">
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" @click="enviarANetSuite(item)" v-on="on" color="purple"> mdi-rotate-right-variant </v-icon>
                    </template>
                    Enviar Factura a NetSuite
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="item.netsuite_id"
                    >
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" @click="openNetsuite(item)" v-on="on" color="green"> mdi-cloud-check </v-icon>
                    </template>
                    Open NetSuite
                  </v-tooltip>
                </td>
              </tr>
            </template> 
          </v-data-table>
          </div>


          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
          <!-- ======================================================================================== -->
        </v-card-text>
        <add-recibo ref="refAddRecibo" @reloadRecibos="loadRecibos"></add-recibo>
        <add-reciboc ref="refAddRecibo3" @reloadRecibos="loadRecibos"></add-reciboc>
        <AddRecibo2 ref="addrecibo2" />
        <show ref="refDetail" @reloadRecibos="loadRecibos"></show>
        <edit-cuenta-bancaria ref="refEditCB"></edit-cuenta-bancaria>
        <print-factura :programa_id="null" ref="refFacturaPrint"></print-factura>
        <Recaudacion ref="recaudacionref" />
      </template>
    </v-card>

    <!-- <v-fab-transition>
      <v-btn
        key="mdi-chevron-up"
        color="primary"
        size="sm"
        fab
        large
        dark
        bottom
        right 
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition> -->

    <Confirm ref="refConfirm" v-on:enviado="loadRecibos"/>
    <momentanea_upi ref="refmomentanea_upi"/>

    <!-- <v-btn @click="corregirAnularFact()"> Anular las Facturas X </v-btn> -->
  </div>
</template>

<style>
.net-green{
  background-color: #edfaed;
}
.tabla-recibos tbody {
  height: 35vh;
  overflow-y: scroll;
}
</style>

<script>
  // ...... https://www.npmjs.com/package/vue-json-excel

  import AddRecibo from './AddRecibo';
  import AddReciboc from './AddRecibo3';
  import AddRecibo2 from './AddRecibo2';
  import Recaudacion from './recaudacion/index';
  import Show from './Show';
  import FilterRecibos from './FilterRecibos';
  import EditCuentaBancaria from './EditCuentaBancaria.vue';
  import PrintFactura from './PrintFactura.vue';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import Confirm from '@/components/AConfirmarNet.vue';
  import VerificarNet from './Reciboslist-verNet.vue'
  import momentanea_upi from '../upi/factura_upi/momentanea_upi.vue';

  export default {
    components: {
      AddRecibo,
      Show,
      FilterRecibos,
      EditCuentaBancaria,
      PrintFactura,
      AddRecibo2,
      AddReciboc,
      Recaudacion,
      Confirm,
      VerificarNet,
      momentanea_upi,
    },
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        date_start: null,
        date_end: null,
        estado: true,
        loadingrecibos: true,
        user: null,
        today: null,
        search: '',
        filtroNetEstado: null,
        items: [],
        items_originales: [],
        sucursales: [],
        puntosventas: [],
        isbenitojuarez: false,
        loadingpuntos: false,
        loadingsucursales: false,
        headers: [
          { text: '#', value: 'index', sortable: false },
          { text: 'Imp. Nets.', value: 'is_impuestos_netsuite', sortable: false },
          { text: 'Depositante', value: 'nombre_depositante' },
          { text: 'N° Recibo', value: 'numero_recibo' },
          { text: 'Items', value: 'detalle.length' },
          { text: 'Fecha De Pago', value: 'fecha_pago' },
          { text: 'Fecha Registro', value: 'fecha_registro' },
          { text: 'Est. Integracion', value: 'estado_integracion' },
          { text: 'Opciones', value: 'actions', sortable: false,width: 180 },
        ],
        headersDeta:[
          {text: 'Empleado', value: 'nombre_empleado'},
          {text: 'Porcentaje', value: 'porcentaje_avance'},
          {text: 'Recibos generados', value: 'cantidad_recibos_generados'},
          {text: 'Recibos enviados', value: 'cantidad_recibos_enviados_netsuite'},
          {text: 'Recibos faltantes', value: 'cantidad_recibos_faltantes_netsuite'},
        ],
        expanded: [],
        expanded2: [],
        sedeid_benitojuarez: 19,
        enviosNetsuite1:{}, 
      };
    },
    watch: {
      '$store.state.CARGO.sede': function (sede) {
        if (this.isbenitojuarez && sede.id != 19) {
          this.$router.push('/recibos');
          return;
        } else if (!this.isbenitojuarez && sede.id == 19) {
          this.$router.push('/recibosbenito');
          return;
        }
        //window.console.log('jajaajajaja');
        this.loadRecibos();
        //SPIDER MAN
      },
      '$route.name': function () {
        this.isbenitojuarez = location.href.includes('recibosbenito');
        this.loadRecibos();
      },
      filtroNetEstado: function(){
        this.filtrarEstadoIntegracion();
      }
    },
    methods: {
      openDialogAddRecibo() {
        this.$refs.refAddRecibo.dialog = true;
      },
      openDialogAddRecibo2() {
        this.$refs.addrecibo2.openmodal();
      },
      openDialogAddRecibo3() {
        this.$refs.refAddRecibo3.dialog = true;
      },
      openDialogDetail(recibo) {
        this.$refs.refDetail.showThisView(recibo);
      },
      openShowEditCB() {
        let recibo_nly_null = this.items.filter((recibo) => !recibo.cuenta_bancaria_id && recibo.forma_pago_id == 2);
        this.$refs.refEditCB.showThisView(this.$store.state.CARGO.sede.id, recibo_nly_null);
      },
      openFacturaPrint(factura_id, recibo) {
        this.$refs.refFacturaPrint.showThisView(factura_id, recibo);
      },
      fechavalidaanular(emitido, hoy) {
        try {
          let fs1 = emitido.split(' ')[0].split('-');
          let fs2 = hoy.split('-');
          let date1 = new Date();
          let date2 = new Date();
          date1.setFullYear(fs1[0]);
          date1.setMonth(fs1[1] - 1);
          date1.setDate(fs1[2]);
          date2.setFullYear(fs2[0]);
          date2.setMonth(fs2[1] - 1);
          date2.setDate(fs2[2]);

          let mes1 = date1.getMonth();
          let mes2 = date2.getMonth();
          let dia2 = date2.getDate();
          let diferencia = mes2 - mes1;

          // diferencia es que estamos en el mismo mes
          // diferencia 1 es que ya paso un mes
          // el dia debe ser menor o igual a 5 dias pasados 1 mes
          if (diferencia == 0) {
            return true;
          } else if (diferencia == 1 && dia2 <= 5) {
            return true;
          }
          return false;
        } catch (e) {
          window.console.error(e);
          return false;
        }
      },
      /*
      async cancelRecibobk(recibo) {
        //const date = this.today.substr(0, 7);
        const fechaAnul = this.fechavalidaanular(recibo.fecha_registro, this.today);
        if (fechaAnul) {
          //if (date === recibo.fecha_registro.substr(0, 7)) {
          if (
            await this.$root.$confirm.open(
              'Estas seguro de anular recibo ???',
              'Los Datos del recibo será eliminado definitivamente y no podrá ser visualizado nuevamente',
              { color: 'orange', width: 400 },
            )
          ) {
            const url = `${this.api_rest}/api/pagos/recibos/id/${recibo.id}`;
            xaxios
              .delete(url)
              .then(() => {
                this.$root.$notify.show(`Recibo Anulado Exitosamente`, { color: 'primary' });
                this.loadRecibos();
              })
              .catch(() => {
                this.$root.$notify.show(`Errorr al Anular el Recibo`, { color: 'amber' });
              });
          }
        }
      },
      */
      async cancelRecibo(recibo){
        let message = {
                title: 'Estas seguro de anular recibo ?',
                body: '<br> <b>NOTA:</b> Esta accion es irreversible',
            };
            let options = {
                html: true,
                okText: 'anular',
                cancelText: 'Cancelar',
                reverse: true,
                type: 'hard',
                verification: 'anular',
                verificationHelp: 'Escriba "[+:verification]" para proceder.',
                loader: true,
            };
            let res = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
            if(res){
              const url = `${this.api_rest}/api/pagos/recibos/id/${recibo.id}`;
              await xaxios
                .delete(url)
                .then(() => {
                  this.$root.$notify.show(`Recibo Anulado Exitosamente`, { color: 'primary' });
                  this.loadRecibos();
                })
                .catch(() => {
                  this.$root.$notify.show(`Error al Anular el Recibo`, { color: 'amber' });
                });
                res.close();
            }
            window.console.log('res',res,recibo)
      },
      async enviarANetSuite(recibo){
        this.$refs.refConfirm.openmodal(recibo); 
      },
      openNetsuite(item){
        window.console.log('item',item);
        const url = process.env.VUE_APP_CASHSALE_NETSUITE+item.netsuite_id;
        window.open(url,'_blank');
      },
      async loadRecibos(showDetail = false, recibo_id = null) {
        // window.console.log('jajaajajaja'); 
        this.loadingrecibos = true;
        this.items = [];
        let vue = this;
        const url = `${this.api_rest}/api/pagos/recibos/buscar`;
        let recibo_by_id = null;
        if(recibo_id){
          const ur = `${this.api_rest}/api/pagos/recibos/id/${recibo_id}`;
          const res = await xaxios.get(ur);
          // window.console.log('1 >>>', res.data);
          recibo_by_id = res.data;  
        }
        // para cargar todo solo de la sede quitar el emisor_id
        let sedeid = this.isbenitojuarez ? this.sedeid_benitojuarez : this.$store.state.CARGO.idsede;
        this.getSucursalesBySede(sedeid);
        let formData = {
          // asesor_id: null,
          // confirmado:true,
          emisor_id:
            this.$store.state.isonlyread ||
            this.$store.state.CARGO.cargo.nombre.toLowerCase() == 'master' ||
            this.$store.state.CARGO.id == 14 ||
            this.$store.state.CARGO.id == 20 ||
            this.$store.state.CARGO.id == 26 ||
            this.$store.state.CARGO.id == 27 ||
            this.$store.state.CARGO.id == 21
              ? null
              : this.user.id,
          estado: this.estado,
          fecha_fin: this.date_end,
          fecha_inicio: this.date_start,
          sede_id: sedeid,
        };

        if(this.$refs.refVerificarNet) this.$refs.refVerificarNet.setData(formData);
        xaxios
          .post(url, formData)
          .then(({ data }) => {
            // window.console.log('data:::', data);
            
            this.loadingrecibos = false;
            data.sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));
            // this.items = data.reverse().map((recibo, i = 0) => {
            this.items = data.map((recibo, i = 0) => {
              recibo.index = ++i;
              recibo.numero_recibo = '000' + recibo.numero_recibo;
              return recibo;
            });
            this.items_originales = JSON.parse(JSON.stringify(this.items));
            // window.console.log(JSON.stringify(this.items), url);
            if(recibo_by_id && showDetail){ 
              recibo_by_id.numero_recibo = '000' + recibo_by_id.numero_recibo;
              this.openDialogDetail(recibo_by_id);

            }
            else if (this.items.length && showDetail) {
              let last = this.items.slice(0);
              this.openDialogDetail(last[0]); 
            }

            this.filtrarEstadoIntegracion();
          })
          .catch((error) => {
            vue.loadingrecibos = false;
            this.$root.$notify.show(`${error.response ? error.response.data.error : 'No hay datos'}`, {
              color: 'primary',
            });

            if(recibo_by_id && showDetail){ 
              recibo_by_id.numero_recibo = '000' + recibo_by_id.numero_recibo;
              this.openDialogDetail(recibo_by_id); 
            }
          });

          this.getEnviosNetsuite();
      },

      /** MANDA A OTRA VISTA PARA FILTRAR DATOS Y DESCARGAR */
      descargarexcel() {
        this.$router.push({ name: 'recibosl' });
      },
      recaudacionopen() {
        this.$refs.recaudacionref.openmodal();
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      getSucursalesBySede(sedeid) {
        let vue = this;
        this.sucursales = [];
        vue.loadingsucursales = true;
        var config = {
          method: 'get',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=1&sucursalId=2=${sedeid}`,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${sedeid}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            //window.console.log('sucursales:', data);
            vue.sucursales = data;
            /*data.forEach((x) => {
                vue.getPuntosVentaBySucursal(x);
              });*/
            vue.loadingsucursales = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingsucursales = false;
          });
      },
      getSedes() {
        this.$apollo
          .query({
            query: gql`query{getSedes{id,nombre} ${''}}`,
          })
          .then((data) => {
            var dat = data.data.getSedes;
            window.console.log('getSedes:> ', dat);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      /*async corregirAnularFact() {
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/addfactura`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            recibo_id: 101064,
            factura_id: 2009,
            numero_factura: 254,
          },
        };

        let res2 = await xaxios.request(config)
          .then(({ data }) => data)
          .catch(() => {});

        window.console.log(res2); 
      },*/

      filtrarEstadoIntegracion(){
        // window.console.log('estado_integracion', this.filtroNetEstado);
        if(this.filtroNetEstado){
          this.items = this.items_originales.filter((recibo) => recibo.estado_integracion == this.filtroNetEstado);
        }else{
          this.items = this.items_originales;
        }
      },

      async getEnviosNetsuite(){
        this.enviosNetsuite1 = {};
        const mes = new Date().getMonth()+1;
        const anio = new Date().getFullYear();
        const sede = this.$store.state.CARGO.sede.id;
        const user = this.$store.state.DATA_USER.id;
        
        const rol = this.$store.state.CARGO.id;
        if(rol == 1 || rol == 15){
          let url = process.env.VUE_APP_API_REST+'/api/v1/esam/reporteenvionetsuite'
          url += `?mes=${mes}&anio=${anio}&sede_id=${sede}&is_agrupado=true`
          const res = await xaxios.get(url).then(({data})=>data);
          const datos = res.data;
          window.console.log('recnet',datos);
          this.enviosNetsuite1 = datos[0];
        }else{
          let url = process.env.VUE_APP_API_REST+'/api/v1/esam/reporteenvionetsuite'
          url += `?mes=${mes}&anio=${anio}&sede_id=${sede}&emisor_id=${user}`
          const res = await xaxios.get(url).then(({data})=>data);
          const datos = res.data;
          // window.console.log('recnet',datos);
          this.enviosNetsuite1 = datos[0];
        }
        if(this.enviosNetsuite1){
          this.enviosNetsuite1.xid = 1;
        }
      },
      vermomentaneo(){
        // lucia
        // lilibeth
        const users = this.$store.state.DATA_USER.id==43 || this.$store.state.DATA_USER.id==137077 || this.$store.state.DATA_USER.id==137075 || this.$store.state.DATA_USER.id==26164
        const devv = (process.env.VUE_APP_GRAPHQL).includes('apidev')
        const sedeid = this.$store.state.CARGO.sede.id== 82
        const isd = users && devv && sedeid
        return isd;
      },
      openUpiMomentaneoFact(){
        this.$refs.refmomentanea_upi.openmodal();
      }
    },
    mounted() {
      // probando
      // this.$store.dispatch('obtenerTokenFactura');
      //this.getSedes();
      // let apitoken = this.$store.getters.getApiKey;
      // window.console.log('token: ', apitoken);

      this.isbenitojuarez = location.href.includes('recibosbenito');
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;
      //   window.console.log('today date recibosList.vue', this.today, this.today.substr(0, 7));

      this.user = this.$store.state.DATA_USER;
      let date = new Date();
      date.setDate(date.getDate() - 5); /** cargar recibos solo de los ultimos 5 dias */
      this.date_start = this.formatDate(date.toISOString().substr(0, 10));
      this.date_end = this.formatDate(new Date().toISOString().substr(0, 10));
      this.loadRecibos();
    },
  };
</script>
